import React from 'react'
const Footer = () => (

<footer>
	<div className="container">
		<div className="row">
			<div className="col-md-12 col-sm-12">
				<ul className="social-icon">
					<li><a href="https://www.facebook.com/DevExperienceRo" target="_blank" className="fa fa-facebook wow fadeIn" data-wow-delay="0.1s"></a></li>
					<li><a href="https://twitter.com/devexperiencero" target="_blank" className="fa fa-twitter wow fadeIn" data-wow-delay="0.1s"></a></li>
					<li><a href="https://www.linkedin.com/company/devexperience/" target="_blank" className="fa fa-linkedin wow fadeIn" data-wow-delay="0.1s"></a></li>
					<li><a href="https://www.instagram.com/devexperiencero/" target="_blank" className="fa fa-instagram wow fadeIn"></a></li>
				</ul>
				<ul className="social-icon">
					<li><a href="/code-of-conduct/">Code of conduct</a></li>
					<li><a href="/privacy/">Privacy Policy</a></li>
				</ul>
				<ul className="social-icon">
					<li><a href="http://2016.devexperience.ro" target="_blank">2016 Edition</a></li>
					<li><a href="http://2017.devexperience.ro" target="_blank">2017 Edition</a></li>
					<li><a href="http://2018.devexperience.ro" target="_blank">2018 Edition</a></li>
					<li><a href="http://2019.devexperience.ro" target="_blank">2019 Edition</a></li>
				</ul>
				<p>Copyright &copy; 2015 - 2020 DevExperience - powered by <a href="http://www.itswise.ro/" target="_blank" className="wow fadeIn" data-wow-delay="0.9s">IT'S WISE</a></p>
			</div>
		</div>
	</div>
</footer>
)


export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/index.js